/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Delivery_2_ValueInputs */

const en_services_delivery_2_value = /** @type {(inputs: Services_Delivery_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real scenarios, clear boundaries and a way to handle exceptions.`)
};

const lv_services_delivery_2_value = /** @type {(inputs: Services_Delivery_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reāli scenāriji, skaidras robežas un veids, kā rīkoties ar izņēmumiem.`)
};

/**
* | output |
* | --- |
* | "Real scenarios, clear boundaries and a way to handle exceptions." |
*
* @param {Services_Delivery_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_delivery_2_value = /** @type {((inputs?: Services_Delivery_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Delivery_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_delivery_2_value(inputs)
	return en_services_delivery_2_value(inputs)
});